import {Graphics, LINE_CAP} from "pixi.js";
import {Polygon} from "detect-collisions";
import {Vector} from "../i.js"; // ../vector.js
import {Random} from "../i.js";
import {ConfigStructure, RequiredProperty} from "../i.js"; // ../validators.js
import {AI} from "../i.js";
import {Thing, THING_TYPES, Z_INDICES} from "../i.js";



// Range of axon lifespans, in seconds
const LIFESPAN_MIN = 2;
const LIFESPAN_MAX = 12;



class AxonAI extends AI {
	// static CONFIG_STRUCTURE = new ConfigStructure([]);

	constructor(thing, config) {
		// CompassAI.CONFIG_STRUCTURE.test(config);

		super(thing);
	}

	move(dt, time) {
		this.thing.age += dt;

		let firstParent = this.thing.space.requestThingById(this.thing.firstParentId);
		let secondParent = this.thing.space.requestThingById(this.thing.secondParentId);

		// Remove the axon without transferring value
		let transferAborted = false;
		// One of the parents destroyed
		if ((firstParent === null) || (secondParent === null)) transferAborted = true;
		// At this point, the first parent should still have the value
		if (!transferAborted && !firstParent.value) logger.error("axon.js",
			"first parent lost value"
		);
		// Second parent already received value from another axon
		if (!transferAborted && secondParent.value) transferAborted = true;
		if (transferAborted) {
			if (firstParent !== null) firstParent.removeOutgoingAxon(false);
			this.thing.prepareToDie(false);
			return;
		}

		// Remove the axon and transfer value
		if (this.thing.age > this.thing.lifespan) {
			// The axon survived its lifespan
			firstParent.removeOutgoingAxon(true);
			secondParent.receiveValue();
			this.thing.prepareToDie(false);
			return;
		}

		if (this.thing.age >= 1.5) this.thing.ready = true;

		this.thing.len = Vector.diff(secondParent.pos, firstParent.pos).mag();
		this.thing.hitbox.setPoints([
			{x: - this.thing.len / 2, y: 0},
			{x:   this.thing.len / 2, y: 0}
		]);
		this.thing.pos = Vector.sum(firstParent.pos, secondParent.pos).scale(0.5);
		// vel remains (0, 0), for now - don't know what the best way to handle it is
		this.thing.rot = Vector.diff(secondParent.pos, firstParent.pos).dir();
	}
}



class AxonAnimation {
	constructor(thing) {
		this.thing = thing;

		this._line = new Graphics();

		this.thing.display.addChild(this._line);
	}

	update(dt, time) {
		this._line.clear();

		if (this.thing.ready) {
			this._line
				.lineStyle({
					width: 0.04,
					color: 0xff0000,
					cap: LINE_CAP.ROUND
				})
				.moveTo(0, - this.thing.len / 2)
				.lineTo(0, this.thing.len / 2)
				.closePath()
				.lineStyle({
					width: 0.02,
					color: 0xffffff,
					cap: LINE_CAP.ROUND
				})
				.moveTo(0, - this.thing.len / 2)
				.lineTo(0, this.thing.len / 2);
		} else {
			this._line
				.lineStyle({
					width: 0.02,
					color: 0xff0000,
					alpha: this.thing.age / 1.5,
					cap: LINE_CAP.ROUND
				})
				.moveTo(0, - this.thing.len / 2)
				.lineTo(0, this.thing.len / 2);
		}
	}
}



export class Axon extends Thing {
	static CONFIG_STRUCTURE = new ConfigStructure([
		// id of the axon's first parent
		new RequiredProperty("firstParentId", v => Number.isFinite(v)),
		// id of the axon's second parent
		new RequiredProperty("secondParentId", v => Number.isFinite(v))
	]);

	// Create a new axon
	// config is an object with the properties provided by the spawn request
	// enrichment, plus the properties specified in CONFIG_STRUCTURE above.
	constructor(config) {
		Axon.CONFIG_STRUCTURE.test(config);

		let firstParent = config.space.requestThingById(config.firstParentId);
		let secondParent = config.space.requestThingById(config.secondParentId);
		console.assert((firstParent !== null) && (secondParent !== null));

		// Fill in missing config fields
		config.name = "Axon";
		config.zIndex = Z_INDICES.NPC_CHILD;
		config.len = Vector.diff(secondParent.pos, firstParent.pos).mag();
		config.hitbox = new Polygon({x: 0, y: 0}, [
			{x: - config.len / 2, y: 0},
			{x:   config.len / 2, y: 0}
		]);
		config.pos = Vector.sum(firstParent.pos, secondParent.pos).scale(0.5);
		config.vel = new Vector();
		config.rot = Vector.diff(secondParent.pos, firstParent.pos).dir();
		config.maxHealth = 12;
		config.type = THING_TYPES.SIZY_WEAPON;
		config.canDespawn = false;

		// Call parent constructor
		super(config);

		this.firstParentId = config.firstParentId;
		this.secondParentId = config.secondParentId;
		this.age = 0;
		this.ready = false;
		this.lifespan = Random.uniform(LIFESPAN_MIN, LIFESPAN_MAX);
		this.ai = new AxonAI(this, {});
		this.animation = new AxonAnimation(this);
	}

	// Take damage from an attack
	// damage is a number.
	takeDamage(damage) {
		// Nothing to do here - a player can't damage an axon directly.
		// TODO: Remove on collision with a station.
	}
}
